import axios from 'axios';
import * as R from 'ramda';

class lookerService {
    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL,
        };
    }

    getLookerDashboardEmbeddedUrls(data) {
        return axios
            .post(this.state.apiUrl + 'home/lookerDashboardUrl', data, {
                silent: true,
            })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    getLookerExploreEmbeddedUrl(data) {
        return axios
            .post(`${this.state.apiUrl}home/lookerExploreUrl`, data, {
                silent: true,
            })
            .then((res) => {
                return res.data;
            })
            .catch((e) => e);
    }
}

/**
 * Get standalone Looker URLs without fetching the whole model and everything else.
 * @param {string|number} modelId - The ID of the model
 * @param {string|number} versionId - The ID of the version
 * @param {object} urlTemplates - An object containing both a chart and a table url template.
 * @param {string} models - A string representation for the module type.
 * @returns {Promise<AxiosResponse<any>>}
 */
function getStandaloneModelEmbedUrl({ modelId, versionId, urlTemplates, models }) {
    return axios
        .post(`${process.env.REACT_APP_API_URL}model/${modelId}/version/${versionId}/looker/url`, {
            urlTemplates,
            models,
        })
        .then(R.prop('data'));
}

/**
 * Todo: move all services to named exports of functions instead of classes
 */
export { getStandaloneModelEmbedUrl };

export default lookerService;
